import * as React from "react"

interface Props {
  color?: string
  small?: boolean
}

const DetailsIcon: React.FunctionComponent<Props> = ({ color = "white", small = false }) => (
  <svg
    width={small ? "19" : "24"}
    height={small ? "19" : "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.9" y="4.9" width="9.2" height="14.2" rx="1.1" stroke={color} strokeWidth="1.8" />
    <line x1="15.3844" y1="5.79434" x2="22.1019" y2="5.79434" stroke={color} strokeWidth="1.8" strokeLinecap="square" />
    <line x1="15.3844" y1="11.7094" x2="22.1019" y2="11.7094" stroke={color} strokeWidth="1.8" strokeLinecap="square" />
    <line x1="15.3844" y1="17.6234" x2="22.1019" y2="17.6234" stroke={color} strokeWidth="1.8" strokeLinecap="square" />
  </svg>
)

export default DetailsIcon
